import Vue from 'vue';
import state from '../state';
import noty from './noty.service';

let clientsPromise = null;

export default {
    ensure() {
        if (!clientsPromise) {
            clientsPromise = Vue.http.get('/api/clients');
            clientsPromise
                .then(response => {
                    state.clients.set(response.data);
                })
                .catch(err => {
                    clientsPromise = null;
                });
        }
        return clientsPromise;
    },
    async reloadAll() {
        const clients = (await Vue.http.get('/api/clients')).data;
        state.clients.set(clients);
    },
    unset() {
        state.clients.set([]);
        clientsPromise = null;
    },
    async save(client) {
        await Vue.http.post('/api/clients', client);
        await this.reloadAll();
        noty.success('Client saved successfully');
    },
    async create(client) {
        await Vue.http.post('/api/clients/create', client);
        await this.reloadAll();
        noty.success('Client created successfully');
    }
};



// WEBPACK FOOTER //
// ./src/services/client.service.js